export default __webpack_public_path__ + "static/NNNittiGrotesk-TextRegular-1ed325a9f36263173d68f210d18e5ccb.eot";